import React from 'react';
import { counterData } from '../../data/data';
import CountUp from 'react-countup';
import sampleVideo from '../../assets/video/video1.mp4';

export default function CtaOne() {
    return (
        <section className="section pt-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="video-solution-cta position-relative" style={{ zIndex: '1' }}>
                            <div className="position-relative">
                                <video
                                    className="img-fluid rounded-md shadow-lg"
                                    src={sampleVideo}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                                />
                            </div>

                            <div className="content mt-4">
                                <div className="row" id="counter">
                                    {counterData.map((item, index) => (
                                        <div className="col-md-4 mt-4 pt-2" key={index}>
                                            <div className="counter-box text-center">
                                                <h1 className="mt-3 text-white title-dark">
                                                    <CountUp className="counter-value" start={0} end={item.target} />
                                                    {item.symbol}
                                                </h1>
                                                <h5 className="counter-head text-white title-dark mb-1">{item.titleOne}</h5>
                                                <p className="text-white-50 mb-0">{item.titleTwo}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feature-posts-placeholder bg-primary"></div>
            </div>
        </section>
    );
}
